import React from "react";

import {
  Grid
} from "@material-ui/core";

function CustomLabel(props) {
  const { label} = props.componentObject;

  return (
    <Grid container>
      <Grid item xs={12} md={4} style={{height: '50px'}}>
          {label}
      </Grid>
        <Grid item xs={12} md={4} />
    </Grid>
  );
}

export default CustomLabel;

